// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__16_5v","signatureBlock":"Footer_signatureBlock__2KHFM","signature":"Footer_signature__DAKcQ"};